var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2033 1.59705L16.5367 4.76372C17.0747 5.03109 17.4151 5.57997 17.4154 6.1808V13.7254C17.4151 14.3262 17.0747 14.8751 16.5367 15.1425L10.2033 18.3091C9.75732 18.5323 9.23224 18.5323 8.78624 18.3091L2.4529 15.1425C1.91536 14.8716 1.57788 14.3194 1.58207 13.7175V6.1808C1.58239 5.57997 1.92276 5.03109 2.46082 4.76372L8.79415 1.59705C9.23799 1.3765 9.75949 1.3765 10.2033 1.59705Z",
    stroke: "url(#paint0_linear_15452_95885)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83594 5.32617L9.49927 9.15784L17.1626 5.32617",
    stroke: "url(#paint1_linear_15452_95885)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.4672V9.15723",
    stroke: "url(#paint2_linear_15452_95885)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15452_95885",
    x1: 11.7655,
    y1: -0.455161,
    x2: 6.52793,
    y2: 4.13216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15452_95885",
    x1: 11.6935,
    y1: 4.90202,
    x2: 11.105,
    y2: 7.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15452_95885",
    x1: 10.0092,
    y1: 8.12665,
    x2: 9.54936,
    y2: 8.16351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.6c6a28f4ecef95fee3b8bdcf0af0843b.svg";
export { ForwardRef as ReactComponent };